import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import calendar from './calendarPage/handler';
import routePlanner from './routePlannerPage/handler';

export default pipeHandlers(common, calendar, routePlanner);
